
import { Component, Vue, Prop } from "vue-property-decorator";
import Avatar from "@/components/Avatar.vue";
import { getCourseDetail } from "@/apis/about";
import { formatUpyunUrl } from "@/utils";
import { getCourseJsonLd, injectJsonLd } from "@/utils/seo";
import Breadcrumb from "@/components/Breadcrumb/index.vue";
import ApplyFormDialog from "@/components/ApplyFormDialog.vue";
@Component({
  components: { Avatar, Breadcrumb, ApplyFormDialog }
})
export default class course extends Vue {
  formatUpyunUrl = formatUpyunUrl;
  course_id = "" as any;
  detail = {} as any;
  show: boolean = false;

  List = [
    { title: "光华商学院", url: "" },
    { title: "公开课", url: "/course" },
    { title: "课程详情", url: "" }
  ];

  endTime() {
    // 同一天
    if (
      this.detail.time_start.substring(0, 10) ==
      this.detail.time_end.substring(0, 10)
    ) {
      return this.detail.time_end.substring(11, 16);
    }
    return this.detail.time_end.substring(5, 16);
  }
  created() {
    // 优先从路径参数获取 id，兼容旧的 query.course_id 参数形式
    this.course_id = (this.$route.params.id || this.$route.query.course_id || "") as string;
    this.getCourseDetail();
  }

  async getCourseDetail() {
    const data = await getCourseDetail({
      origin: 1,
      course_id: this.course_id
    });
    this.detail = data;
    // 注入 Course JSON-LD
    if (data && data.title) {
      injectJsonLd(
        "jsonld-course",
        getCourseJsonLd({
          name: data.title,
          description:
            data.intro && Array.isArray(data.intro)
              ? data.intro
                  .filter((i: any) => i.type === "p")
                  .map((i: any) => i.value)
                  .join(" ")
                  .substring(0, 300)
              : data.title,
          instructor: data.teacher_expand || (data.teacher && data.teacher[0] ? data.teacher[0].name : undefined),
          startDate: data.time_start ? data.time_start.substring(0, 10) : undefined,
          endDate: data.time_end ? data.time_end.substring(0, 10) : undefined,
          image: data.image ? formatUpyunUrl(data.image) : undefined
        })
      );
    }
  }

  mounted() {
    const metaTag1 = document.createElement("meta");
    metaTag1.setAttribute("name", "keywords");
    metaTag1.setAttribute(
      "content",
      "光华介绍，光华师资，光华动态，客户案例，效果看得见，"
    );
    document.head.appendChild(metaTag1);
    const metaTag2 = document.createElement("meta");
    metaTag2.setAttribute("name", "description");
    metaTag2.setAttribute(
      "content",
      "企业培训咨询数字化转型，找光华，企业培训咨询数字化转型 |，找光华，服务一万家企业绩效飞轮*应用实践，帮助一万家企业BLM科学经营T系统落地，到2035年，赋能陪跑企业合计GDP超一万亿规模，用科学经营助推企业高质量发展讲师说明：董权、霍振先、潘亦藩、蔡毅臣、杨波、方永飞 所有老师的名字动态说明：动态标题，客户案例说明：客户案例标题"
    );
    document.head.appendChild(metaTag2);
  }
}
